import React, { useState, useEffect, memo } from 'react';
import Portal from '../../styled-base/portal';
import ConfidenceFlagHover from "./confidenceFlagHover.component";
import { getBoundingClientRect } from '../../styled-base/menu/utils'
import {getOffset} from "../../utils/common";

const ConfidenceHoverBefore = (props) => {
    const getInitialPosition = () => ({
        x: -300,
        y: -300
      });
    const [data, setData] = useState(getInitialPosition())
    useEffect(() => {
        const rect = getBoundingClientRect(props.currentElement || $(`#confIt-${props.id}`)[0]);
        let offsetVal ='';
        if (props.currentElement) {
            offsetVal = getOffset(props.currentElement);
        } else {
            offsetVal = getOffset(document.getElementById(`#confIt-${props.id}`))
        }
        
        if(offsetVal.top - $(window).scrollTop() > 250){
            setData({
                x: rect ? (rect.x || rect.left) - 20 : 0,
                y: rect ? window.scrollY +(rect.y || rect.top)- 25 - $('.confidence-hover-body').height() : 0
            });
        } else {
            setData({
                x: rect ? (rect.x || rect.left) - 20 : 0,
                y: rect ?window.scrollY + (rect.y || rect.top) : 0
            });
        }
        return () => {
            setData({
                x: 0,
                y: 0
            })
          }
    },[])
    return(
        <div>
        <Portal position={data} centerY={false}>
            <div>
            <ConfidenceFlagHover {...props}
            currentElement={props.currentElement} />
            </div>
        </Portal>
        </div>
    
    )
}
export default memo(ConfidenceHoverBefore);